import './index.scss'
import Swiper from 'swiper/swiper-bundle.min.js'
$(".product-nav dl dt").click(function() {
    $(this).parent().toggleClass("active");
    $(this).parent().find(".dd").slideToggle();
})

var swiper = new Swiper(".mySwiper", {
    spaceBetween: '4%',
    slidesPerView: 4,
    direction: 'vertical',

});
var swiper2 = new Swiper(".mySwiper2", {
    thumbs: {
        swiper: swiper,
    },
});